import script from "./apizacoPage.vue?vue&type=script&setup=true&lang=js"
export * from "./apizacoPage.vue?vue&type=script&setup=true&lang=js"

import "./apizacoPage.vue?vue&type=style&index=0&id=0888b9f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0888b9f6"]])

export default __exports__